import React from 'react';

class CompanyModal extends React.Component{
	constructor(props){
    super(props)
		this.state = {
			show: false,
			companyList: null
		}
  }
  waitForSF() {
  	let that = this;
		let sfResult = window.sf$.sf5.latestSearch.results
		if(typeof sfResult && sfResult.names.length > 0){
			let sfData = {
				'title': sfResult.names,
				'address': sfResult.data,
				'id': sfResult.ids
			}
			if (sfData.title) {
				if (sfData.title.length > 0) {
					let companyList = [];
					for (var i = 0; i < sfData.title.length; i++) {
						companyList.push({
							name: encodeURIComponent(sfData.title[i]),
							label: encodeURIComponent(sfData.title[i]),
							addr: sfData.address[i],
							id: sfData.id[i]
						})						
					}
					that.setState({
						companyList: companyList,
						show: true
					})
				} 
			}
		}else{
			setTimeout(that.waitForSF.bind(that), 250);
		}
	}
	
	refreshCompanyField(){
		document.getElementById("Company").dispatchEvent(window.companyUpdate);
	}
	
	openModal(){
		this.refreshCompanyField()
		this.waitForSF()
	}
  selectCompanyHandler(e){
		e.preventDefault()
		let index = e.currentTarget.dataset.id;
		let currentItem = this.state.companyList[index];
		// window.sf$.clearHidden();
		window.sf$.sf5.fields$.clearFieldSet(['matched', 'site', 'du', 'gu','inferred','contact']);
		let companyID = currentItem.id,
				companyName = currentItem.name;

		if (companyID !== 0) {
			// window.sf$.getDetails( companyName, companyID );
			window.sf$.sf5.httpCalls.companyFetch(companyName, companyID)
			window.myForm.addHiddenFields({
				'Company': decodeURIComponent(companyName)
			});
			this.refreshCompanyField()
			window.company = decodeURIComponent(companyName)
			this.props.setCompanyField(decodeURIComponent(companyName), true)
		}else{
      this.props.setCompanyField(window.company, true)
			window.sf$.sf5.httpCalls.match(true) 
		}
    this.setState({
      show: false
    })
	}
  render() {
    return (
			<div className={"modal " + (this.state.show ? ' active' : '')}>

					<h2>We found a few companies that might match what you entered.</h2>
					<hr className="stubby" />
					<p>Please select your company below:</p>
					{ this.state.companyList &&
					<ul className="companyList">
						{this.state.companyList.map((item, index) => (
								<li key={item.id}>
									<a href="#item" data-id={index} onClick={this.selectCompanyHandler.bind(this)}>
										{decodeURIComponent(item.label)}
										<span className="sub-addr" dangerouslySetInnerHTML={{__html: item.addr}} />
									</a>
								</li>
						))}
					</ul>
					}

			</div>
    );
  }
}
CompanyModal.displayName = "CompanyModal"
export default CompanyModal